import React, { FC } from 'react'
import { Card, AdminSwitchCard, StoreSwitchCard } from 'components/Card'
import { MainHeadline, SubDescription } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getIsAdmin, getSwitchingStoreRefs } from 'reducks/auth/selectors'
import { SwitchingStoreRefType } from 'types/auth'

const StoreSwitchCardList: FC = React.memo(() => {
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const switchingStoreRefs: SwitchingStoreRefType[] = useSelector((state: State) => getSwitchingStoreRefs(state))
  return (
    <section>
      <MainHeadline headline={'店舗の切り替え'} />
      <Spacer size={12} />
      <SubDescription
        description={'別の店舗で、注文状況の確認や商品の出品をするには切り替えボタンを押してください。'}
      />
      <Spacer size={20} />
      <Card>
        {isAdmin && <AdminSwitchCard />}
        {switchingStoreRefs.map((switchingStoreRef) => (
          <StoreSwitchCard
            key={
              switchingStoreRef.store_ref.id +
              (switchingStoreRef.manufacturer_ref ? switchingStoreRef.manufacturer_ref.id : '')
            }
            switchingStoreRef={switchingStoreRef}
          />
        ))}
      </Card>
    </section>
  )
})

export default StoreSwitchCardList
